(() => {
  const labels = { en: 'Language', ja: '言語', ko: '언어', ms: 'Bahasa', vi: 'Ngôn ngữ' };
  let scheduled = false;
  const synchronize = () => {
    scheduled = false;
    const current = document.querySelector('.fullbelief-language-options a.gt-current-lang[data-gt-lang]');
    if (!current) return;
    const code = current.getAttribute('data-gt-lang');
    const title = current.getAttribute('aria-label') || current.title || code.toUpperCase();
    document.querySelectorAll('[data-fb-language]').forEach(menu => {
      if (!menu.querySelector('a[data-gt-lang]')) return;
      menu.setAttribute('data-fb-language-ready', 'true');
      const text = menu.querySelector('[data-fb-language-code]');
      if (text.textContent !== code.toUpperCase()) text.textContent = code.toUpperCase();
      const label = (labels[code] || labels.en) + ': ' + title;
      const summary = menu.querySelector('summary');
      if (summary.getAttribute('aria-label') !== label) summary.setAttribute('aria-label', label);
      menu.querySelectorAll('a[data-gt-lang]').forEach(link => {
        if (link.getAttribute('data-gt-lang') === code) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    });
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(synchronize);
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('.fullbelief-language-options a[data-gt-lang]');
    if (link) {
      const menu = link.closest('[data-fb-language]');
      if (menu) {
        menu.open = false;
        menu.querySelector('summary').focus();
      }
      schedule();
    }
    document.querySelectorAll('[data-fb-language][open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('[data-fb-language][open]');
    if (menu) {
      menu.open = false;
      menu.querySelector('summary').focus();
      event.preventDefault();
    }
  });
  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  document.addEventListener('shopify:section:load', schedule);
  synchronize();
})();
